import { getContextDeep } from "@builder/store/slices/BuilderSlice/builderHelpers";
import { isCopyable, isDeletable, noAscend } from "@builder/store/slices/BuilderSlice/builderMap";
import { getSelectedNode } from "@builder/store/slices/BuilderSlice/builderSelectors";
import { copyNode, deleteNode, selectParent } from "@builder/store/slices/BuilderSlice/builderSlice";
import { setLeftInstance } from "@builder/store/slices/sidebarSlice";
import { useAppDispatch, useAppSelector } from "@builder/store/store";
import { Popper } from "@mui/material";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import "./style.scss";

const SelectedMenu = () => {
    const selectedNode = useAppSelector(getSelectedNode);
    const dispatch = useAppDispatch();
    const [element, setElement] = useState<HTMLElement>();
    const frameTransform = useAppSelector(state => state.frameTransform);
    const { t } = useTranslation();
    const builderState = useAppSelector(state => state.builder);
    const cvMode = useAppSelector(state => state.builder.conditionalVariationMode);

    const dataType = getContextDeep(builderState, selectedNode?.id) || "general";

    const buildSettingsKey = useAppSelector(state => state.buildSettingsKey);

    useEffect(() => {
        let intervalId: NodeJS.Timeout;
        if (selectedNode?.id) {
            intervalId = setInterval(() => {
                const id = cvMode?.id === selectedNode.id ? `${cvMode.id}|${cvMode.index}` : selectedNode.id;
                const el = document.getElementById(id);
                if (el) {
                    setElement(el);
                    clearInterval(intervalId);
                }
            }, 50);
        }
        return () => {
            clearInterval(intervalId);
        };
    }, [selectedNode, frameTransform, cvMode]);

    if (!selectedNode) return null;

    const dynamicDataName =
        selectedNode.dynamicData && buildSettingsKey?.[selectedNode?.dynamicData]
            ? buildSettingsKey[selectedNode.dynamicData].label
            : selectedNode?.dynamicData
            ? `${t(`popup.popupSidebar.dynamicData.${dataType}`)}: ${t(`dynamicDataString.${selectedNode.dynamicData}`)}`
            : t(`builderElements.${selectedNode.name}`);

    const handleSelectParent = () => {
        dispatch(setLeftInstance("editElement"));
        dispatch(selectParent());
    };

    const duplicateNode = () => {
        dispatch(copyNode());
    };

    const handleDeleteNode = () => {
        if (selectedNode) {
            dispatch(setLeftInstance("addElement"));
            dispatch(deleteNode(selectedNode.id));
        }
    };

    if (selectedNode && element) {
        return (
            <Popper
                open
                anchorEl={element}
                className="base-Popper-root"
                placement="top-start"
                modifiers={[
                    {
                        name: "flip",
                        enabled: false
                    },
                    {
                        name: "preventOverflow",
                        enabled: false
                    }
                ]}
            >
                <div className="selected-menu-container">
                    <div className="selected-menu-wrapper">
                        {!noAscend.includes(selectedNode.name) && (
                            <div onClick={handleSelectParent}>
                                <img src="./angled-arrow-down.svg" alt="" />
                            </div>
                        )}

                        {<span>{selectedNode.customName || dynamicDataName}</span>}

                        {isCopyable(selectedNode) && (
                            <div onClick={duplicateNode}>
                                <img src="./copy-icon.svg" alt="" />
                            </div>
                        )}
                        {isDeletable(selectedNode) && (
                            <div onClick={handleDeleteNode}>
                                <img src="./trash.svg" alt="" />
                            </div>
                        )}
                    </div>
                    <div className="dotted-line"></div>
                </div>
            </Popper>
        );
    } else {
        return null;
    }
};

export default SelectedMenu;
